import { useEffect } from "react";
import { Skeleton } from "@/components/ui/skeleton";

const REFRESH_KEY = "__skeleton_auto_refresh__";

export const BlogSkeleton = () => {
  useEffect(() => {
    const alreadyRefreshed = sessionStorage.getItem(REFRESH_KEY);
    if (alreadyRefreshed) return;

    const timer = setTimeout(() => {
      sessionStorage.setItem(REFRESH_KEY, "true");
      window.location.reload();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Page header section */}
      <section className="py-12 md:py-16 bg-card">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center space-y-4">
            <Skeleton className="h-16 w-16 rounded-full mx-auto" />
            <Skeleton className="h-12 w-32 mx-auto" />
            <Skeleton className="h-6 w-80 max-w-full mx-auto" />
          </div>
        </div>
      </section>

      {/* Search and filter bar skeleton */}
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row gap-4 items-center justify-between mb-8">
          <Skeleton className="h-10 w-full md:w-80 rounded-md" />
          <div className="flex flex-wrap gap-2 justify-center">
            {[1, 2, 3, 4, 5].map((i) => (
              <Skeleton key={i} className="h-9 w-20 rounded-full" />
            ))}
          </div>
        </div>

        {/* Blog grid skeleton */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="space-y-3 rounded-lg border border-border overflow-hidden">
              <Skeleton className="aspect-video w-full" />
              <div className="space-y-2 p-4">
                <div className="flex items-center gap-2">
                  <Skeleton className="h-5 w-16 rounded-full" />
                  <Skeleton className="h-4 w-24" />
                </div>
                <Skeleton className="h-6 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-4 w-24 mt-2" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
